"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function IntroParagraph() {
  const { currentLang } = useLanguage();
  const isEs = currentLang === "es";

  if (isEs) {
    return (
      <section className="max-w-3xl mx-auto py-10">
        <div className="space-y-4 text-gray-700 leading-relaxed">
          <p>
            Cada temporada de huracanes, los propietarios de Miami enfrentan la misma pregunta: ¿instalar ventanas con clasificación de impacto o desplegar persianas para huracanes? La respuesta no es única para todos — depende de cuánto tiempo planea quedarse, su presupuesto, sus objetivos de seguro y cómo usa su casa día a día.
          </p>
          <p>
            Esta comparación desglosa seis criterios de decisión uno al lado del otro. Usamos datos reales de Miami-Dade de 2026, incluyendo rangos de descuento de seguro, estudios de valor de reventa y plazos de instalación. Al final, tendrá una recomendación clara adaptada a su tipo de propiedad.
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="max-w-3xl mx-auto py-10">
      <div className="space-y-4 text-gray-700 leading-relaxed">
        <p>
          Every hurricane season, Miami homeowners face the same question: install impact-rated windows or deploy hurricane shutters? The answer is not one-size-fits-all — it depends on how long you plan to stay, your budget, your insurance goals, and how you use your home day-to-day.
        </p>
        <p>
          This comparison breaks down six decision criteria side by side. We use real Miami-Dade data from 2026, including insurance discount ranges, resale value studies, and installation timelines. By the end, you will have a clear recommendation tailored to your property type.
        </p>
      </div>
    </section>
  );
}